import React from "react";
import { JsonSchemaForm } from "react-jsonschema-form";

import {
  Edit,
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  ReferenceInput,
  SelectInput,
  required,
  BooleanInput,
  ImageInput,
  ImageField
} from "react-admin";

import { FormToolbar } from "../../common/FormToolbar";
import { Authorizer } from "../../common/Authorizer";
import { useStyles } from "../../common/formStyles";
export const ActivityCreate = (props) => {
  const classes = useStyles({});
  let propsObj = Authorizer(props,"Create"); 
  let tenantID = localStorage.getItem("TenantID");
  let facilityID = localStorage.getItem("FacilityID");
  let userID = localStorage.getItem("userId");
  let defaultValues = {
  //  tenantId: tenantID,
    // facilityId: facilityID,
    
    createdDate: new Date(),
    createdBy: userID,
    isActive: true
  };
  return (
    <Create {...propsObj}> 
      <SimpleForm redirect="list" initialValues={defaultValues}
        toolbar={<FormToolbar {...props} showDelete={false} />} variant="outlined" > 
         
       
       <TextInput source="subjects" label="Subject Name"  fullWidth={true}  validate={[required()]} /> 
       <TextInput source="subjectDet" label="Subject Det"  multiline fullWidth={true} /> 
       <BooleanInput source="isActive" validate={[required()]}  label="Active" initialValue={true}/>  
              </SimpleForm>
    </Create>
  );
};
